import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from '../../../environments/environment';
import { ItokenFirebase } from "../../domain/interfaces/firebase/Itoken";
import { FirebaseGatewayAbstract } from "../../domain/model/firebase/gateway/auth-farebase.abstract";


@Injectable({
    providedIn: 'root'
})
export class FirebaseAuthenticationService extends FirebaseGatewayAbstract {
    private url: string;
    private port: string;

    constructor(private http: HttpClient) {
        super();
        this.url = `${environment.apiBaseUrl}`;
        this.port = `${environment.portBaseUrl}`;
    }

    public getToken(): Observable<ItokenFirebase> {
        const URL = `${this.url}${this.port}/api_novedades/fireauth/obtenerToken`;
        return this.http.get(URL, { withCredentials: true, responseType: 'text' }).pipe(
            map(token => ({ token }))
        );
    }

}